function LinkImage({ image = "" }: { image: string }) {
  return <img src={image} alt="user img" className="max-h-full" />;
}

export default LinkImage;
